<template>
  <div id="lander">
    <LanderHeader v-if="config" :config="config" />

    <div id="main">
      <h4 v-if="config" class="sub" v-html="mainTitle" />

      <div class="inner">
        <div class="frm">
          <slot />
        </div>

        <div v-if="config" class="faqs">
          <LanderWelcome :config="config" />
          <LanderLinks :config="config" />
          <LanderFaq :config="config" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import LanderHeader from "./LanderHeader.vue";
import LanderWelcome from "./LanderWelcome.vue";
import LanderLinks from "./LanderLinks.vue";
import LanderFaq from "./LanderFaq.vue";

const props = defineProps({
  config: {
    type: Object,
    default: null,
  },
});

const mainTitle = computed(() => {
  if (!props.config) return "";
  if (props.config.main_title) return props.config.main_title;
  return `Book a flight for your ${props.config.org_label || ""} program`;
});
</script>
